import { COOKIE_KEYS } from '@/constants/cookies';

export enum AuthEndpoints {
  SIGN_IN = '/auth/sign-in',
  SIGN_IN_VERIFY = '/auth/sign-in/verify',
  REFRESH_TOKEN = '/auth/sign-in/refresh',
  FORGOT_PASSWORD = '/auth/forgot-password',
  RESET_PASSWORD = '/auth/reset-password',
  CHANGE_PASSWORD = '/auth/change-password',
  LOG_OUT = '/auth/log-out',
}

export enum AdminSignInActions {
  SIGN_IN = 'SIGN_IN',
  CREATE_NEW_PASSWORD = 'CREATE_NEW_PASSWORD',
  SETUP_MFA = 'SETUP_MFA',
  CONFIRM_OTP = 'CONFIRM_OTP',
}

// ============== DTO ==============

export interface IAuthorizedRequestDTO {
  [COOKIE_KEYS.AUTH_TOKEN]?: string;
}

export interface ISignInDTO {
  email: string;
  password: string;
}

export interface ISignInVerifyDTO {
  data: string;
  session: string;
}

export interface IRefreshTokenDTO {
  refreshToken: string;
}

export interface IForgotPasswordDTO {
  email: string;
}

export interface IResetPasswordDTO {
  code: string;
  session: string;
  newPassword: string;
}

export interface ILogOutDTO {
  refreshToken: string;
}

export interface IChangePasswordDTO {
  token: string;
  oldPassword: string;
  newPassword: string;
}

// ============== Response ==============

export interface ISignInResponse {
  action: AdminSignInActions;
  qrCode?: string;
  secretCode?: string;
  session: string;
}

export interface ISignInAuthorizedResponse {
  idToken: string;
  refreshToken: string;
}
